// Project Imports
import Product from 'constants/ProductConstants';

const fetchBetterHalfBenefit = (solutionData) => {
    let betterHalfBenefitsList = []

    solutionData.coverage.forEach((coverage) => {
        coverage.life_assured_list.forEach(lifeAssured => {
            lifeAssured.product_details.forEach(obj => {
                let betterHalfBenefit = fetchInputStringOpt('@PR_OPTION_2', obj.data.InputString) === "3"
                let benefitMessage = ""
                switch (obj.product_name) {
                    case Product.ZINDAGI_PROTECT:   
                    if (betterHalfBenefit) {
                        let BetterHalfbenefitAmount = obj.data.OutputJSON[0][0].BHB_SA
                        BetterHalfbenefitAmount = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', currencyDisplay: 'name' }).format(BetterHalfbenefitAmount).split('.')[0];
                        let SpouseName = fetchInputStringOpt('@OPTION_VALUE_3', obj.data.InputString)
                        let LAName = fetchInputStringOpt('@LI_NAME', obj.data.InputString)
                            benefitMessage =`${SpouseName} gets additional cover of Rs ${BetterHalfbenefitAmount} of Base Sum Assured in absence of ${LAName}` 
                            if (!checkBenefitAvailable(benefitMessage, betterHalfBenefitsList))
                                betterHalfBenefitsList.push(benefitMessage)
                        }
                        break;
                }
            })
        })
    })
    return betterHalfBenefitsList
}

const fetchInputStringOpt = (key, inputString) => {
    return inputString.filter((item) => item.Key == key)[0]?.Value || 'NO'
}

const checkBenefitAvailable = (benefit, coverList) => {
    return coverList.some((item) => item === benefit)
}

export default fetchBetterHalfBenefit